import React from "react";

export default function InnovarAutomotriz({
  titulo,
  parrafos1,
  parrafos2,
  parrafos3,
}) {
  return (
    <section className="w-full bg-[#181B2C] py-12 flex flex-col items-center justify-center">
      {titulo && (
        <h2 className="text-center text-3xl md:text-4xl lg:text-5xl font-extrabold text-sidom-orange mb-8">
          {titulo}
        </h2>
      )}
      <div className="max-w-6xl mx-auto flex flex-col gap-6 text-white text-center px-4">
        {parrafos1 && (
          <p className="text-lg md:text-xl lg:text-2xl">{parrafos1}</p>
        )}
        {parrafos2 && (
          <p className="text-lg md:text-xl lg:text-2xl">{parrafos2}</p>
        )}
        {parrafos3 && (
          <p className="text-lg md:text-xl lg:text-2xl">{parrafos3}</p>
        )}
      </div>
    </section>
  );
}
